import { ModuleFE_FHIRResource } from './ModuleFE_FHIRResource.js';
export const ModulePackFE_FHIRResourceDB = [ModuleFE_FHIRResource];
//# sourceMappingURL=module-pack.js.map